// The kebab key is dead under the current LDProvider config (camelCase keys are
// the SDK default), but it matches the in-repo precedent and survives a future
// `useCamelCaseFlagKeys: false`.
export function isScV3Enabled(flags: Record<string, unknown>): boolean {
  return Boolean(flags['flag-sc-v3'] ?? flags['flagScV3']);
}
